export const DirectoryCard = {
  extends: 'Link',
  href: (el, s) => (s._type === 'firm' ? '/firm' : '/lawyer') + '?slug=' + (s.slug || s.id),
  textDecoration: 'none',
  color: 'inherit',
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  theme: 'card',
  cursor: 'pointer',
  transition: 'all 0.25s ease',
  border: (el, s) => s.isSubscribed ? '1px solid green.3' : '1px solid transparent',
  ':hover': { boxShadow: 'black.08 0 Z B', transform: 'translateY(-2px)' },

  CardHeader: {
    flow: 'x',
    align: 'flex-start space-between',
    gap: 'A',

    HeaderLeft: {
      flow: 'x',
      align: 'flex-start flex-start',
      gap: 'A',
      flex: '1',
      minWidth: '0',

      Avatar: {
        tag: 'img',
        width: 'C',
        height: 'C',
        round: (el, s) => s._type === 'firm' ? 'Z' : 'C',
        flexShrink: '0',
        objectFit: 'cover',
        src: (el, s) => s.photoUrl || s.avatar || s.logo || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(s.nameEn || '') + '&background=1a2332&color=c6ac8f&size=96&bold=true&format=svg'
      },

      NameGroup: {
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        Name: { text: (el, s) => s.nameEn, fontSize: 'A', fontWeight: '600', letterSpacing: '-0.01em' },
        NameKa: { text: (el, s) => s.nameKa, fontSize: 'Z', opacity: '0.6' },
        SubLine: {
          flow: 'x', gap: 'Y', align: 'center',
          SubText: {
            text: (el, s) => {
              if (s._type === 'firm') {
                const parts = [s.city]
                if (s.foundedYear) parts.push('Est. ' + s.foundedYear)
                return parts.join(' \u00B7 ')
              }
              return s.firmNameEn || 'Independent'
            },
            fontSize: 'Z',
            opacity: '0.5',
            fontStyle: (el, s) => s._type !== 'firm' && !s.firmNameEn ? 'italic' : 'normal'
          },
          VerifiedBadge: {
            show: (el, s) => s.isSubscribed,
            text: '\u2605 Verified',
            fontSize: 'X',
            fontWeight: '700',
            color: 'green',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            padding: 'V Y',
            background: 'greenBg',
            round: 'W'
          }
        }
      }
    },

    StatusRating: {
      show: (el, s) => s._type !== 'firm',
      flow: 'y',
      gap: 'Z',
      align: 'flex-end flex-end',
      flexShrink: '0',
      RatingBadge: {
        flow: 'x', gap: 'Y', align: 'center center',
        padding: 'Y Z', round: 'Z', theme: 'success',
        show: (el, s) => s.reviews > 40,
        RatingStar: { text: '\u2605', fontSize: 'Z' },
        RatingVal: { text: (el, s) => String(s.rating), fontSize: 'Z', fontWeight: '600' }
      },
      StatusBadge: {
        flow: 'x', gap: 'Y', align: 'center center',
        StatusDot: { width: 'Y', height: 'Y', borderRadius: '100%', background: (el, s) => s.status === 'active' ? 'green' : 'red' },
        StatusText: { text: (el, s) => s.status, fontSize: 'Z', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.05em', color: (el, s) => s.status === 'active' ? 'green' : 'red' }
      }
    }
  },

  CardMeta: {
    flow: 'x',
    gap: 'Z',
    flexWrap: 'wrap',
    align: 'center flex-start',
    marginTop: 'Z',
    opacity: '0.6',
    fontSize: 'Z',
    MetaCity: { text: (el, s) => s.city },
    MetaDot1: { text: '\u00B7' },
    MetaDetail: {
      text: (el, s) => {
        if (s._type === 'firm') return (s.lawyerCount || 0) + ' lawyers'
        return (s.reviews || 0) + ' reviews'
      }
    },
    MetaDot2: { show: (el, s) => s._type !== 'firm', text: '\u00B7' },
    MetaExtra: {
      show: (el, s) => s._type !== 'firm',
      text: (el, s) => s.barId || ''
    },
    MetaPhone: {
      show: (el, s) => s._type === 'firm' && s.phone,
      text: (el, s) => '\u00B7 ' + (s.phone || '')
    }
  },

  CardTags: {
    flow: 'x',
    gap: 'Y',
    flexWrap: 'wrap',
    marginTop: 'Z',
    children: (el, s) => {
      const tags = s._type === 'firm' ? (s.practiceAreas || []) : (s.specializations || [])
      return tags.slice(0, 3).map(t => ({ label: t }))
    },
    childrenAs: 'state',
    childProps: {
      text: (el, s) => s.label,
      fontSize: 'Z',
      padding: 'Y Z',
      round: 'C',
      theme: 'secondary',
      fontWeight: '500'
    }
  }
}
